import { Card, CardContent } from '@/components/ui/card';
import { getLanguage, t } from '@/i18n';
import type { SalesSummary } from '@ip/shared-types';
import { formatPLN } from '@/utils/currency';

interface SalesSummaryCardsProps {
  summary: SalesSummary;
}

interface Tile {
  title: string;
  value: string;
}

function StatTile({ tile }: { tile: Tile }) {
  return (
    <Card className="py-4">
      <CardContent className="px-4">
        <p className="text-muted-foreground truncate text-xs font-medium" title={tile.title}>
          {tile.title}
        </p>
        <p className="mt-1 flex items-center gap-1.5 font-mono text-lg font-semibold tabular-nums">
          <span className="truncate">{tile.value}</span>
        </p>
      </CardContent>
    </Card>
  );
}

export function SalesSummaryCards({ summary }: SalesSummaryCardsProps) {
  const now = new Date();
  const locale = getLanguage() === 'pl' ? 'pl-PL' : 'en-GB';
  const month =
    now.getFullYear() === summary.year ? now.toLocaleString(locale, { month: 'short' }) : '-';
  const money = (v: number) => `${formatPLN(v)} PLN`;

  const tiles: Tile[] = [
    { title: t('sales.totalNet'), value: money(summary.totalNet) },
    { title: t('sales.currentMonthNet', { month }), value: money(summary.currentMonthNet) },
    { title: t('sales.invoiceCount'), value: String(summary.invoiceCount) },
    { title: t('sales.avgNet'), value: money(summary.avgNet) },
  ];

  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
      {tiles.map((tile) => (
        <StatTile key={tile.title} tile={tile} />
      ))}
    </div>
  );
}
